import { NumberFormat } from '../DataTableWidget/types';
import { RankedTableWidgetOptionsImpl } from './options';

export const METRIC_VALUE_FORMAT_VS_NUMBER_FORMAT: {
    [key in RankedTableWidgetOptionsImpl['metricValueFormat']]: NumberFormat;
} = {
    '1k': {
        decimals: 0,
        usePretty: true,
    },
    '1.2k': {
        decimals: 1,
        usePretty: true,
    },
    '1.23k': {
        decimals: 2,
        usePretty: true,
    },
    '1,234': {
        decimals: 0,
        usePretty: false,
    },
};
